<template lang="html">
  <div
    class="categories-wrapper"
    :class="{ collaps: collaps && !openCategories }"
  >
    <div class="categories-title" @click="openCategories = !openCategories">
      <!-- <img src="@/assets/icons/bars.png" alt="categories icon"> -->
      <span>{{ $t("main.categories") }}</span>
      <img
        v-if="collaps"
        src="@/assets/newImges/icons/btnRight.svg"
        alt="slider btn right"
        :class="{ rotate: openCategories }"
      />
    </div>
    <div v-if="openCategories" class="categories">
      <div
        v-for="category in categories"
        :key="category.cat_id"
        class="category"
      >
        <div :class="{ active: category.open }" class="category-title">
          <span
            :class="{ active: category.cat_id === active }"
            @click="openCategory(category)"
            >{{ category.cat_name }}</span
          >
          <div
            v-if="category.subCategories && category.subCategories.length > 0"
            @click="category.open = !category.open"
            class="dropdown-arrow-wrapper"
          >
            <img
              src="@/assets/icons/dropdownArrow.png"
              alt="dropdown arrow icon"
            />
          </div>
        </div>
        <div v-if="category.subCategories && category.open" class="dropdown">
          <div
            v-for="sub in category.subCategories"
            :key="sub.cat_id"
            @click="openCategory(sub)"
            class="sub"
            :class="{ active: sub.cat_id === active }"
          >
            <span>{{ sub.cat_name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "categories",
  props: {
    categories: {
      type: Array,
      required: false,
      default: () => {
        return [];
      }
    },
    active: {
      type: Number,
      required: false
    },
    collaps: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      openCategories: true
    };
  },
  methods: {
    openCategory(category) {
      this.$emit("changeCategory", category);
    }
  },
  mounted() {
    if (this.collaps) {
      this.openCategories = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/scrollbarStyles.scss";
.categories-wrapper {
  width: 264px;
  min-width: 264px;
  // padding-top: 20px;
  // padding-left: 20px;
  padding: 22px;
  min-height: 150px;
  height: auto;
  position: relative;
  padding-bottom: 20px;
  margin-right: 24px;
  background-color: $gray-blue-100;
  border: 1px solid $gray-blue-500;
  border-radius: 12px;
  box-sizing: border-box;
  font-family: Outfit;
  text-align: left;

  .categories-title {
    display: flex;
    align-items: center;

    justify-content: space-between;

    img {
      margin-left: 13px;
      cursor: pointer;
      transition-duration: 0.2s;
    }
    .rotate {
      transform: rotate(90deg);
    }
    span {
      font-weight: 500;
      font-style: Medium;
      font-size: 20px;
      line-height: 100%;
      letter-spacing: 0%;
      text-transform: capitalize;
      color: $blue-1000;
    }
  }
  .categories {
    margin-top: 20px;
    position: absolute;
    width: calc(100% - 20px);
    direction: rtl;
    overflow: auto;
    height: calc(100% - 80px);

    .category {
      position: relative;
      direction: ltr;
      padding: 0 20px 0px 25px;

      .category-title {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        min-height: 30px;

        span {
          font-weight: 400;
          font-style: Regular;
          font-size: 16px;
          line-height: 150%;
          letter-spacing: 0%;
          // vertical-align: middle;
          color: $blue-400;

          transition-duration: 0.2s;
          cursor: pointer;
        }
        span.active {
          color: $blue-1000;
        }
        .dropdown-arrow-wrapper {
          width: 20px;
          height: 20px;
          // height: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;

          img {
            transition-duration: 0.2s;
          }
        }
      }
      .category-title:hover {
        span {
          color: $blue-1000;
        }
      }
      .category-title.active {
        img {
          transform: rotate(180deg);
        }
        span {
          color: $blue-1000;
        }
      }
      .dropdown {
        text-align: left;
        padding-left: 15px;
        padding-top: 7px;

        .sub {
          font-weight: normal;
          font-size: 12px;
          line-height: 20px;
          letter-spacing: 0.06em;
          color: $blue-400;
          margin-bottom: 5px;

          span {
            cursor: pointer;
            transition-duration: 0.2s;
          }
          span:hover {
            color: $blue-1000;
          }
        }
        .sub.active {
          span {
            color: $blue-1000;
          }
        }
      }
    }
  }
}
.categories-wrapper.collaps {
  min-height: 64px;
  max-height: 64px;
  height: fit-content;
  margin-bottom: 5px !important;
}
.small-nav-wrapper {
  .categories {
    position: relative !important;
  }
}
.slider-categories-wrapper {
  .categories {
    position: relative !important;
    max-height: 470px;
  }
}
</style>
